import { FEATURE_FLAGS } from "@/constants";

import { useFeatureFlag } from "./useFeatureFlag";

const useHasOtherCreationFeatures = () => {
  const { hasFeatureFlag: hasVoice } = useFeatureFlag(FEATURE_FLAGS.TTS);

  return {
    hasVoice,
    hasAnyCreationFeatures: true,
  };
};

export default useHasOtherCreationFeatures;
